import axios, { AxiosError, AxiosResponse } from "axios";
import {
    IServiceResult,
    IStore,
    IUserPreferences,
    ITerritoryType,
} from "../../Models/Models";
import { IUserPreferencesAxios } from "../IUserPreferencesAxios";

export class UserPreferencesAxios implements IUserPreferencesAxios {
    public GetUserPreferences(): Promise<IServiceResult<IUserPreferences>> {
        const promise = new Promise<IServiceResult<IUserPreferences>>(
            (resolve, reject) => {
                axios
                    .get<IServiceResult<IUserPreferences>>("/Users/GetPreferences")
                    .then(
                        (response: AxiosResponse) => {
                            resolve(response.data);
                        },
                        (error: AxiosError) => {
                            reject(error);
                        }
                    );
            }
        );

        return promise;
    }

    public GetAllCommunitySites(): Promise<IServiceResult<Array<IStore>>> {
        const promise = new Promise<IServiceResult<Array<IStore>>>(
            (resolve, reject) => {
                axios.get<IServiceResult<Array<IStore>>>("/Community/GetAllSites").then(
                    (response: AxiosResponse) => {
                        resolve(response.data);
                    },
                    (error: AxiosError) => {
                        reject(error);
                    }
                );
            }
        );

        return promise;
    }

    public UpdateUserPreferences(
        userPreferences: IUserPreferences
    ): Promise<IServiceResult<IUserPreferences>> {
        const promise = new Promise<IServiceResult<IUserPreferences>>(
            (resolve, reject) => {
                axios
                    .post<IServiceResult<IUserPreferences>>("/Users/UpdatePreferences", userPreferences)
                    .then(
                        (response: AxiosResponse) => {
                            resolve(response.data);
                        },
                        (error: AxiosError) => {
                            reject(error);
                        }
                    );
            }
        );

        return promise;
    }

    public GetCompanyTerritoryTypes(): Promise<
    IServiceResult<Array<ITerritoryType>>
    > {
        const promise = new Promise<IServiceResult<Array<ITerritoryType>>>(
            (resolve, reject) => {
                axios
                    .get<IServiceResult<Array<ITerritoryType>>>("/Territories/Types")
                    .then(
                        (response: AxiosResponse) => {
                            resolve(response.data);
                        },
                        (error: AxiosError) => {
                            reject(error);
                        }
                    );
            }
        );

        return promise;
    }
}
